import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "acceptedOption",
    "acceptedOptionContainer",
    "declineReason",
    "declineReasonContainer",
    "fileInput",
    "fileLabel",
    "status"
  ]

  static values = {
    proofAttached: Boolean,
    savedStatus: String
  }

  // A form shown again with a status chosen but not saved asks for that status's fields too.
  connect() {
    this.changeStatus()
  }

  // Each status asks for its own fields, and the ones of the status left behind no longer hold the form back.
  changeStatus() {
    this.#toggleAcceptedOption()
    this.#toggleDeclineReason()
    this.#requireProofOfConfirmation()
  }

  #isStatus(status) {
    return this.statusTarget.value === status
  }

  // An accepted quote names the option its seller accepted.
  #toggleAcceptedOption() {
    const isStatusAccepted = this.#isStatus("accepted")
    this.acceptedOptionContainerTarget.classList.toggle("d-none", !isStatusAccepted)
    this.acceptedOptionTarget.disabled = !isStatusAccepted
  }

  // A quote being accepted needs its proof of confirmation, unless one is attached already; a quote saved as accepted
  // has had its proof.
  #requireProofOfConfirmation() {
    const required = this.#isStatus("accepted") && this.savedStatusValue !== "accepted" && !this.proofAttachedValue
    this.fileLabelTarget.classList.toggle("required", required)
    this.fileInputTarget.required = required
  }

  #toggleDeclineReason() {
    const isStatusDeclined = this.#isStatus("declined")
    this.declineReasonContainerTarget.classList.toggle("d-none", !isStatusDeclined)
    this.declineReasonTarget.disabled = !isStatusDeclined
  }
}
